/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./school-ficecode.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./school-ficecode.component";
import * as i3 from "@angular/router";
import * as i4 from "../../classes/common-values";
import * as i5 from "../../services/blocking-indicator/blocking-indicator.service";
import * as i6 from "../../services/school/school.service";
import * as i7 from "../../services/schools/schools.service";
import * as i8 from "../../services/system-messages/system-messages.service";
import * as i9 from "../../services/property/property-config.service";
import * as i10 from "../../services/data/data.service";
var styles_SchoolFiceCodeComponent = [i0.styles];
var RenderType_SchoolFiceCodeComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SchoolFiceCodeComponent, data: {} });
export { RenderType_SchoolFiceCodeComponent as RenderType_SchoolFiceCodeComponent };
export function View_SchoolFiceCodeComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_SchoolFiceCodeComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "nsc-school-ficecode", [], null, null, null, View_SchoolFiceCodeComponent_0, RenderType_SchoolFiceCodeComponent)), i1.ɵdid(1, 245760, null, 0, i2.SchoolFiceCodeComponent, [i3.ActivatedRoute, i4.CommonValues, i5.BlockingIndicatorService, i3.Router, i6.SchoolService, i7.SchoolsService, i8.SystemMessagesService, i9.PropertyConfigService, i10.DataService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SchoolFiceCodeComponentNgFactory = i1.ɵccf("nsc-school-ficecode", i2.SchoolFiceCodeComponent, View_SchoolFiceCodeComponent_Host_0, {}, {}, []);
export { SchoolFiceCodeComponentNgFactory as SchoolFiceCodeComponentNgFactory };
